module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "entries"
    }
  }, [_c('v-client-table', {
    staticClass: "entry-table data-table custom-data-table",
    attrs: {
      "data": _vm.entriesList,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "#4a4a4a"
          },
          on: {
            "click": function($event) {
              return _vm.removeEntry(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-885acbc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-885acbc0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/entryManager.pug
// module id = 1448
// module chunks = 0